import { SelectMenuAddIcon } from './SelectMenuAddIcon.js';
import { SelectMenuCreateItem } from './SelectMenuCreateItem.js';
import { SelectMenuDialog } from './SelectMenuDialog.js';
import { SelectMenuHeader } from './SelectMenuHeader.js';
import { SelectMenuIcon } from './SelectMenuIcon.js';
import { SelectMenuItem } from './SelectMenuItem.js';
import { SelectMenuList } from './SelectMenuList.js';
import { type ComponentPropsWithRef } from 'react';
import { css, styled } from 'styled-components';

const StyledContainer = styled.div<{
  $hasFixedPosition?: boolean;
}>`
  ${({ $hasFixedPosition = false }) => css`
    ${$hasFixedPosition &&
    css`
      position: fixed;
      margin-top: 20px;
    `}
  `}
`;

type SelectMenuProps = ComponentPropsWithRef<'div'> & {
  readonly hasFixedPosition?: boolean;
};

const SelectMenu = ({
  children,
  hasFixedPosition = false,
  ...props
}: SelectMenuProps) => (
  <StyledContainer
    $hasFixedPosition={hasFixedPosition}
    {...props}
  >
    {children}
  </StyledContainer>
);

SelectMenu.AddIcon = SelectMenuAddIcon;
SelectMenu.Dialog = SelectMenuDialog;
SelectMenu.Header = SelectMenuHeader;
SelectMenu.Icon = SelectMenuIcon;
SelectMenu.Item = SelectMenuItem;
SelectMenu.List = SelectMenuList;
SelectMenu.CreateItem = SelectMenuCreateItem;

export { SelectMenu };
